module.exports = function (app, mod) {
  return "";
};